// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1pfck","hideOnTablet":"styles_hideOnTablet__1K_WN","hideOnMobile":"styles_hideOnMobile__2l9fT","card":"styles_card__J3F9r"};